import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    class: { "create-annotations-button-container": true, active: this.isAttributeEnabled(`active`) }
  }, /* @__PURE__ */ jsx(TooltipEl, {
    placement: Placement.Top
  }, "Add Annotation"), /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `plus` }
  }));
}
